export function isEmail(email) {
  const er = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; /* eslint-disable-line */
  if(er.test(email)) {
    return true;
  }
  return false;
}
